import React from 'react';
import { NavLink } from 'react-router-dom';

export default function SettingsSubsectionHeader({ title, actions = null }) {
	return (
		<div className="settings-subsection-header">
			<div className="settings-subsection-header-start">
				<NavLink
					to="/ats/settings"
					className="settings-back-btn button-border-soft-small is-icon-only"
					aria-label="Back to Settings">
					<img src="/ats/icons/chevron-left-icon.svg" alt="" />
				</NavLink>
				<h2>{title}</h2>
			</div>
			{actions ? (
				<div className="settings-subsection-header-actions">{actions}</div>
			) : null}
		</div>
	);
}
